import { http } from "Utils/http";
import { httpDownload } from "Utils/httpDownload";
import { EDIT_ORG_FORM_DATA } from 'Containers/Private/Organization/Edit/EditOrganizationFormData'
import { STATUSES } from "Utils/constants";
import { setGlobalErrorStatus, setGlobalSuccessStatus } from 'Components/StatusHandling'
import { store } from 'Store';
import { NUMBER_PATTERN, NAME_PATTERN } from "Utils/constants";

// Load deleted PSE Test Batches data
const getOrganizationByType = async (orgType, datatableFilter) => {
    var formData = {
        orgType: orgType,
        dataTableParams: datatableFilter
    }
    const loginState = store.getState().loginInfo;
    const token = "Bearer " + loginState.token;
    //let data = new XMLHttpRequest();
    //data.
    //let data = new FormData();
    //data.append('orgType', orgType);
    //data.set
    //data.append('req', JSON.stringify(formData));
    //data.append('request', new Blob([JSON.stringify(formData)],{type: 'application/json'}));
    var url = '/api/getOrganizationByType';

    const res = await http.post(url, formData, {
        headers: {
            "Content-Type": "application/json",
            "Authorization": token
            //"Referrer-Policy": "strict-origin-when-cross-origin"
        }
    }).then(res => {
        //console.log("statuses");
        //console.log(res);

        return Promise.resolve({ status: 0, data: res });

    }).catch(function (error) {
        //console.log(error);
        //console.log("error caught from loadCompletedPSETestBatches()");
        //alert("error caught from loadCompletedPSETestBatches()");
        //setIsCompletedPSETestBatchPending(false);
        //if (!showPopup) {
        //setShowPopup(true);
        //setPopMsg({
        //title: "Data Error",
        //msg: "At this time, we are experiencing problems retrieving the data."
        //});
        //}

        return Promise.reject({ status: -1, data: error });
    });
    return res;
};

const loadFormInfo = async (orgType, ACTIONS, formInfoDispatch, handleSelectChange, handleInputTextChange, handleInputDateChange, handleRadioChange, handleCheckChange, handleInputTelChange, listValues, orgId) => {

    formInfoDispatch({
        type: ACTIONS.SET_INITIAL_DATA,
        data: '',
        loading: true
    })

    var data = {

    }
    const loginState = store.getState().loginInfo;
    const token = "Bearer " + loginState.token;

    //var url = '/api/manage/'+ orgType +'/viewOrganizationDetail';
    var url = '/api/manage/' + orgType + '/createOrganization';
    const res = await http.post(url, data, {
        headers: {
            "Authorization": token
            //"Content-Type": "multipart/form-data"
        }
    }).then(res => {
        //console.log(res);
        const orgStates = listValues.stateListValues(res.data.demographics);
        const contactStates = listValues.stateListValues(res.data.demographics);
        const statuses = listValues.orgStatusValues(res.data.organizationStatuses);
        const prefix = listValues.prefixListValues(res.data.prefixList);
        const suffix = listValues.suffixListValues(res.data.suffixList);



        return {
            orgStates: orgStates,
            contactStates: contactStates,
            statuses: statuses,
            prefix: prefix,
            suffix: suffix
        }

    }).then((obj) => {
        var data = {
            orgName: {
                value: null,
                validation: {
                    required: true,
                    isInvalid: false,
                    errors: []
                },
                onChange: handleInputTextChange,
                disabled: false,
                readOnly: false,

            },
            orgId: {
                value: '',
                validation: {
                    required: function () {
                        if (orgType !== "Admin") {
                            return true;
                        }
                        else {
                            return false;
                        }
                    },
                    isInvalid: false,
                    errors: []
                },
                onChange: handleInputTextChange,
                disabled: false,
                readOnly: function () {
                    if (orgType !== "Admin") {
                        return false;
                    }
                    else {
                        return true;
                    }
                },

            },
            orgURL: {
                value: '',
                validation: {
                    required: false,
                    isInvalid: false,
                    errors: []
                },
                onChange: handleInputTextChange,
                disabled: false,
                readOnly: false,

            },
            orgAddr1: {
                value: '',
                validation: {
                    required: true,
                    isInvalid: false,
                    errors: []
                },
                onChange: handleInputTextChange,
                disabled: false,

            },
            orgAddr2: {
                value: '',
                validation: {
                    required: false,
                    isInvalid: false,
                    errors: []
                },
                onChange: handleInputTextChange,
                disabled: false,

            },
            orgCity: {
                value: '',
                validation: {
                    required: true,
                    isInvalid: false,
                    errors: []
                },
                onChange: handleInputTextChange,
                disabled: false,

            },
            orgState: {
                value: '',
                options: obj.orgStates,
                validation: {
                    required: true,
                    isInvalid: false,
                    errors: []
                },
                onChange: handleSelectChange,
                disabled: false,
                readOnly: false,

            },
            orgZip: {
                value: '',
                validation: {
                    required: true,
                    isInvalid: false,
                    errors: []
                },
                onChange: (e) => handleInputTextChange(e, NUMBER_PATTERN),
                disabled: false,

            },
            orgZipExt: {
                value: '',
                validation: {
                    required: false,
                    isInvalid: false,
                    errors: []
                },
                onChange: (e) => handleInputTextChange(e, NUMBER_PATTERN),
                disabled: false,

            },
            orgPhone: {
                value: '',
                validation: {
                    required: true,
                    isInvalid: false,
                    errors: []
                },
                onChange: handleInputTelChange,
                disabled: false,

            },
            orgPhoneExt: {
                value: '',
                validation: {
                    required: false,
                    isInvalid: false,
                    errors: []
                },
                onChange: (e) => handleInputTextChange(e, NUMBER_PATTERN),
                disabled: false,

            },
            orgFax: {
                value: '',
                validation: {
                    required: false,
                    isInvalid: false,
                    errors: []
                },
                onChange: handleInputTelChange,
                disabled: false,

            },
            orgStatus: {
                radioButtons: obj.statuses,
                validation: {
                    required: true,
                    isInvalid: false,
                    errors: []
                },

            },
            orgIsSCPEnrolled: {
                radioButtons: [
                    {
                        id: 0,
                        label: "Yes",
                        name: "orgIsSCPEnrolled",
                        value: "Yes",
                        title: "Organization Enrolled in Software Certification Process",
                        isChecked: false,
                        onChange: handleRadioChange,
                        disabled: false
                    },
                    {
                        id: 1,
                        label: "No",
                        name: "orgIsSCPEnrolled",
                        value: "No",
                        title: "Organization Not Enrolled in Software Certification Process",
                        isChecked: false,
                        onChange: handleRadioChange,
                        disabled: false
                    }
                ],
                validation: {
                    required: true,
                    isInvalid: false,
                    errors: []
                },

            },
            orgSCPEnrollDate: {
                value: '',
                validation: {
                    required: true,
                    isInvalid: false,
                    errors: []
                },
                onChange: handleInputDateChange,
                disabled: false,

            },
            orgIsTest: {
                radioButtons: [
                    {
                        id: "0",
                        label: "Yes",
                        name: "orgIsTest",
                        value: "Yes",
                        title: "Is Test Organization",
                        isChecked: false,
                        onChange: handleRadioChange,
                        disabled: false
                    },
                    {
                        id: "1",
                        label: "No",
                        name: "orgIsTest",
                        value: "No",
                        title: "Is Not Test Organization",
                        isChecked: false,
                        onChange: handleRadioChange,
                        disabled: false
                    }
                ],
                validation: {
                    required: true,
                    isInvalid: false,
                    errors: []
                },

            },
            orgListingDate: {
                value: '',
                validation: {
                    required: true,
                    isInvalid: false,
                    errors: []
                },
                onChange: handleInputDateChange,
                disabled: false,

            },
            contactFirstName: {
                value: '',
                validation: {
                    required: true,
                    isInvalid: false,
                    errors: []
                },
                onChange: handleInputTextChange,
                //onChange: (e) => handleInputTextChange(e, NAME_PATTERN),
                disabled: false,

            },
            contactMiddleName: {
                value: '',
                validation: {
                    required: false,
                    isInvalid: false,
                    errors: []
                },
                onChange: handleInputTextChange,
                disabled: false,

            },
            contactLastName: {
                value: '',
                validation: {
                    required: true,
                    isInvalid: false,
                    errors: []
                },
                onChange: handleInputTextChange,
                //onChange: (e) => handleInputTextChange(e, NAME_PATTERN),
                disabled: false,

            },
            contactPrefix: {
                value: '',
                options: obj.prefix,
                validation: {
                    required: false,
                    isInvalid: false,
                    errors: []
                },
                onChange: handleSelectChange,
                disabled: false,

            },
            contactSuffix: {
                value: '',
                options: obj.suffix,
                validation: {
                    required: false,
                    isInvalid: false,
                    errors: []
                },
                onChange: handleSelectChange,
                disabled: false,

            },
            contactCreds: {
                value: '',
                validation: {
                    required: false,
                    isInvalid: false,
                    errors: []
                },
                onChange: handleInputTextChange,
                disabled: false,

            },
            contactJobTitle: {
                value: '',
                validation: {
                    required: false,
                    isInvalid: false,
                    errors: []
                },
                onChange: handleInputTextChange,
                disabled: false,

            },
            contactBusinessAddr1: {
                value: '',
                validation: {
                    required: true,
                    isInvalid: false,
                    errors: []
                },
                onChange: handleInputTextChange,
                disabled: false,

            },
            contactBusinessAddr2: {
                value: '',
                validation: {
                    required: false,
                    isInvalid: false,
                    errors: []
                },
                onChange: handleInputTextChange,
                disabled: false,

            },
            contactCity: {
                value: '',
                validation: {
                    required: true,
                    isInvalid: false,
                    errors: []
                },
                onChange: handleInputTextChange,
                disabled: false,

            },
            contactState: {
                value: '',
                options: obj.contactStates,
                validation: {
                    required: true,
                    isInvalid: false,
                    errors: []
                },
                onChange: handleSelectChange,
                disabled: false,
                readOnly: false,

            },
            contactZip: {
                value: '',
                validation: {
                    required: true,
                    isInvalid: false,
                    errors: []
                },
                onChange: (e) => handleInputTextChange(e, NUMBER_PATTERN),
                disabled: false,

            },
            contactZipExt: {
                value: '',
                validation: {
                    required: false,
                    isInvalid: false,
                    errors: []
                },
                onChange: (e) => handleInputTextChange(e, NUMBER_PATTERN),
                disabled: false,

            },
            contactPhone: {
                value: '',
                validation: {
                    required: true,
                    isInvalid: false,
                    errors: []
                },
                onChange: handleInputTelChange,
                disabled: false,

            },
            contactPhoneExt: {
                value: '',
                validation: {
                    required: false,
                    isInvalid: false,
                    errors: []
                },
                onChange: (e) => handleInputTextChange(e, NUMBER_PATTERN),
                disabled: false,

            },
            contactFax: {
                value: '',
                validation: {
                    required: false,
                    isInvalid: false,
                    errors: []
                },
                onChange: handleInputTelChange,
                disabled: false,

            },
            contactEmail: {
                value: '',
                validation: {
                    required: true,
                    isInvalid: false,
                    errors: []
                },
                onChange: handleInputTextChange,
                disabled: false,

            },
            contactConfirmEmail: {
                value: '',
                validation: {
                    required: true,
                    isInvalid: false,
                    errors: []
                },
                onChange: handleInputTextChange,
                disabled: false,

            },
            contactVerify: {
                checkBoxes: [
                    {
                        id: "contactVerify",
                        label: "I verify the above user information is correct.",
                        title: "Check the checkbox to verify if the above User Information is correct",
                        name: "contactVerify",
                        value: false,
                        isChecked: false,
                        onChange: handleCheckChange,
                        disabled: false
                    }
                ],
                validation: {
                    required: true,
                    isInvalid: false,
                    errors: []
                },

            }
        }
        formInfoDispatch({
            type: ACTIONS.SET_INITIAL_DATA,
            data: //CREATE_ORG_FORM_DATA({orgType, obj, handleSelectChange, handleInputTextChange, handleRadioChange, handleCheckChange}) ,
                data,//CreateOrganizationFormData({orgType, obj, handleSelectChange, handleInputTextChange, handleRadioChange, handleCheckChange}),

            loading: false
        })

        //console.log(CreateOrganizationFormData({orgType, obj, handleSelectChange, handleInputTextChange, handleRadioChange, handleCheckChange}));

    }).catch(function (error) {
        //console.log("error caught from loadCompletedPSETestBatches()");
        //console.log(error);
    });
};

const submitCreateOrganizationData = async (orgType, formInfo, nameConverter, addErrorMessages, clearErrorMessages, getFieldValue) => {

    clearErrorMessages(formInfo.data);

    //console.log("submit file");

    var request = {
        orgDetails: {
            "name": getFieldValue("orgName", formInfo.data),
            "psoId": getFieldValue("orgId", formInfo.data).toUpperCase(),
            "website": getFieldValue("orgURL", formInfo.data),
            "address1": getFieldValue("orgAddr1", formInfo.data),
            "address2": getFieldValue("orgAddr2", formInfo.data),
            "city": getFieldValue("orgCity", formInfo.data),
            "regionId": getFieldValue("orgState", formInfo.data),
            "zip": getFieldValue("orgZip", formInfo.data),
            "zipExtension": getFieldValue("orgZipExt", formInfo.data),
            "phone": getFieldValue("orgPhone", formInfo.data),
            "extension": getFieldValue("orgPhoneExt", formInfo.data),
            "fax": getFieldValue("orgFax", formInfo.data),
            "statusId": getFieldValue("orgStatus", formInfo.data),
            "scpEnroll": getFieldValue("orgIsSCPEnrolled", formInfo.data),
            "scpEnrollDate": getFieldValue("orgSCPEnrollDate", formInfo.data),
            "testOrg": getFieldValue("orgIsTest", formInfo.data),
            "listingEffectiveDate": getFieldValue("orgListingDate", formInfo.data)
        },
        userBean: {
            "firstname": getFieldValue("contactFirstName", formInfo.data),
            "middlename": getFieldValue("contactMiddleName", formInfo.data),
            "lastname": getFieldValue("contactLastName", formInfo.data),
            "prefix": getFieldValue("contactPrefix", formInfo.data),
            "suffix": getFieldValue("contactSuffix", formInfo.data),
            "credentials": getFieldValue("contactCreds", formInfo.data),
            "jobTitle": getFieldValue("contactJobTitle", formInfo.data),
            "address1": getFieldValue("contactBusinessAddr1", formInfo.data),
            "address2": getFieldValue("contactBusinessAddr2", formInfo.data),
            "city": getFieldValue("contactCity", formInfo.data),
            "state": getFieldValue("contactState", formInfo.data),
            "zip": getFieldValue("contactZip", formInfo.data),
            "zipext": getFieldValue("contactZipExt", formInfo.data),
            "phoneForDisplay": getFieldValue("contactPhone", formInfo.data),
            "phoneext": getFieldValue("contactPhoneExt", formInfo.data),
            "faxForDisplay": getFieldValue("contactFax", formInfo.data),
            "emailaddress": getFieldValue("contactEmail", formInfo.data),
            "confirmemailaddress": getFieldValue("contactConfirmEmail", formInfo.data),
            "verifiedByUser": getFieldValue("contactVerify", formInfo.data)
        }
    }
    const loginState = store.getState().loginInfo;
    const token = "Bearer " + loginState.token;
    var url = '/api/manage/' + orgType + '/addOrganization';

    var status = STATUSES.SUCCESS;

    const res = await http.post(url, request, {
        headers: {
            "Authorization": token
        }
    }).then(res => {
        var x = 0;
        var isFirst = false;
        for (const [key, value] of Object.entries(nameConverter)) {
            //console.log(`Key: ${key}, Value: ${value}`);

            var d = res.fieldErrors;
            var values = d[key];

            if (values != null) {
                if (x == 0) {
                    isFirst = true;
                }
                else {
                    isFirst = false;
                }
                addErrorMessages(value, key, res, isFirst);
                status = STATUSES.ERROR;
                x = x + 1;
            }


        }



        return Promise.resolve({ status: status, data: res });

    }).catch(function (error) {
        //console.log("error caught from loadCompletedPSETestBatches()");
        //console.log(error);
        status = STATUSES.ERROR;;
        return Promise.reject({ status: status, data: error });
    });
    return res;
};

const getEditOrgData = async (passedData, ACTIONS, formInfoDispatch, handleSelectChange, handleInputTextChange, handleInputDateChange, handleRadioChange, handleCheckChange, handleInputTelChange, listValues) => {
    formInfoDispatch({
        type: ACTIONS.SET_INITIAL_DATA,
        data: '',
        loading: true
    })

    var orgType = passedData.orgType;
    //console.log(orgType);

    var call = {
        organizationId: passedData.id
    }
    //console.log("CALL");
    //console.log(call);
    var url = '/api/manage/' + orgType + '/editOrganization';
    var status = STATUSES.SUCCESS;
    const loginState = store.getState().loginInfo;
    const token = "Bearer " + loginState.token;
    const res = await http.post(url, call, {
        headers: {
            //"Content-Type": "multipart/form-data"

            //"Referrer-Policy": "strict-origin-when-cross-origin"
            //"Access-Control-Allow-Origin": "*"
            "Authorization": token
        }
    }).then(res => {
        //console.log(res);
        //console.log(listValues.stateListValues);
        const orgDetails = res.data.orgDetails;
        const orgStates = listValues.stateListValues(res.data.demographics, orgDetails.regionId);
        const statuses = listValues.orgStatusValues(res.data.organizationStatuses, orgDetails.statusId);


        return {
            orgStates: orgStates,
            statuses: statuses,
            orgDetails: orgDetails
        }

    }).then((obj) => {

        const dets = obj.orgDetails;

        const getDateFormat = (value) => {
            if (value != null) {
                var split = value.split('/');
                //console.log(split);
                if (split.length == 3) {
                    return split[2] + '-' + split[0] + '-' + split[1];
                }
                return value;
            }
            return "";
        }

        var data = {

            orgName: {
                value: dets.name != null ? dets.name : "",
                validation: {
                    required: true,
                    isInvalid: null,
                    errors: []
                },
                onChange: handleInputTextChange,
                disabled: false,
                readOnly: false
            },
            orgId: {
                value: dets.psoId != null ? dets.psoId : "",
                validation: {
                    required: function () {
                        if (orgType !== "Admin") {
                            return true;
                        }
                        else {
                            return false;
                        }
                    },
                    isInvalid: null,
                    errors: []
                },
                onChange: handleInputTextChange,
                disabled: function () {
                    if (orgType !== "Admin") {
                        return false;
                    }
                    else {
                        return true;
                    }
                },
                readOnly: function () {
                    if (orgType !== "Admin") {
                        return false;
                    }
                    else {
                        return true;
                    }
                }
            },
            orgURL: {
                value: dets.website != null ? dets.website : "",
                validation: {
                    required: false,
                    isInvalid: null,
                    errors: []
                },
                onChange: handleInputTextChange,
                disabled: false,
                readOnly: false
            },
            orgAddr1: {
                value: dets.address1,
                validation: {
                    required: true,
                    isInvalid: null,
                    errors: []
                },
                onChange: handleInputTextChange,
                disabled: false
            },
            orgAddr2: {
                value: dets.address2 != null ? dets.address2 : "",
                validation: {
                    required: false,
                    isInvalid: null,
                    errors: []
                },
                onChange: handleInputTextChange,
                disabled: false
            },
            orgCity: {
                value: dets.city,
                validation: {
                    required: true,
                    isInvalid: null,
                    errors: []
                },
                onChange: handleInputTextChange,
                disabled: false
            },
            orgState: {
                value: dets.regionId,
                options: obj.orgStates,
                validation: {
                    required: true,
                    isInvalid: null,
                    errors: []
                },
                onChange: handleSelectChange,
                disabled: false,
                readOnly: false
            },
            orgZip: {
                value: dets.zip != null ? dets.zip : "",
                validation: {
                    required: true,
                    isInvalid: null,
                    errors: []
                },
                onChange: (e) => handleInputTextChange(e, NUMBER_PATTERN),
                disabled: false
            },
            orgZipExt: {
                value: dets.zipExtension != null ? dets.zipExtension : "",
                validation: {
                    required: false,
                    isInvalid: null,
                    errors: []
                },
                onChange: (e) => handleInputTextChange(e, NUMBER_PATTERN),
                disabled: false
            },
            orgPhone: {
                value: dets.phone,
                validation: {
                    required: true,
                    isInvalid: null,
                    errors: []
                },
                onChange: handleInputTelChange,
                disabled: false
            },
            orgPhoneExt: {
                value: dets.extension != null ? dets.extension : "",
                validation: {
                    required: false,
                    isInvalid: null,
                    errors: []
                },
                onChange: (e) => handleInputTextChange(e, NUMBER_PATTERN),
                disabled: false
            },
            orgFax: {
                value: dets.fax != null ? dets.fax : "",
                validation: {
                    required: false,
                    isInvalid: null,
                    errors: []
                },
                onChange: handleInputTelChange,
                disabled: false
            },
            orgStatus: {
                radioButtons: obj.statuses,
                validation: {
                    required: true,
                    isInvalid: null,
                    errors: []
                }
            },
            orgIsSCPEnrolled: {
                radioButtons: [
                    {
                        id: 0,
                        label: "Yes",
                        name: "orgIsSCPEnrolled",
                        value: "Yes",
                        title: "Organization Enrolled in Software Certification Process",
                        isChecked: dets.scpEnroll == "Yes" ? true : false,
                        onChange: handleRadioChange,
                        disabled: false
                    },
                    {
                        id: 1,
                        label: "No",
                        name: "orgIsSCPEnrolled",
                        value: "No",
                        title: "Organization Not Enrolled in Software Certification Process",
                        isChecked: dets.scpEnroll == "No" ? true : false,
                        onChange: handleRadioChange,
                        disabled: false
                    }
                ],
                validation: {
                    required: true,
                    isInvalid: null,
                    errors: []
                }
            },
            orgSCPEnrollDate: {
                value: getDateFormat(dets.scpEnrollDate),
                validation: {
                    required: true,
                    isInvalid: null,
                    errors: []
                },
                onChange: handleInputDateChange,
                disabled: false
            },
            orgIsTest: {
                radioButtons: [
                    {
                        id: "0",
                        label: "Yes",
                        name: "orgIsTest",
                        value: "Yes",
                        title: "Is Test Organization",
                        isChecked: dets.testOrg == "Yes" ? true : false,
                        onChange: handleRadioChange,
                        disabled: false
                    },
                    {
                        id: "1",
                        label: "No",
                        name: "orgIsTest",
                        value: "No",
                        title: "Is Not Test Organization",
                        isChecked: dets.testOrg == "No" ? true : false,
                        onChange: handleRadioChange,
                        disabled: false
                    }
                ],
                validation: {
                    required: true,
                    isInvalid: null,
                    errors: []
                }
            },


            agreementEffectiveDate: {
                value: getDateFormat(dets.agreementEffectiveDate),
                validation: {
                    required: false,
                    isInvalid: null,
                    errors: []
                },
                onChange: handleInputDateChange,
                disabled: false
            },
            listingEffectiveDate: {
                value: getDateFormat(dets.listingEffectiveDate),
                validation: {
                    required: true,
                    isInvalid: null,
                    errors: []
                },
                onChange: handleInputDateChange,
                disabled: false
            },
            agreementEndDate: {
                value: getDateFormat(dets.agreementEndDate),
                validation: {
                    required: false,
                    isInvalid: null,
                    errors: []
                },
                onChange: handleInputDateChange,
                disabled: false
            },
            listingEndDate: {
                value: getDateFormat(dets.listingEndDate),
                validation: {
                    required: false,
                    isInvalid: null,
                    errors: []
                },
                onChange: handleInputDateChange,
                disabled: false
            },
            password: {
                value: '',
                validation: {
                    required: true,
                    isInvalid: null,
                    errors: []
                },
                onChange: handleInputTextChange,
                disabled: false
            }
        }


        formInfoDispatch({
            type: ACTIONS.SET_INITIAL_DATA,
            data: data,//EDIT_ORG_FORM_DATA(orgType, obj, handleSelectChange, handleInputTextChange, handleRadioChange) 
            loading: false
        })

        const additionalOrganizationInfo = {
            organizationId: dets.organizationId,
            organizationTypeId: dets.organizationTypeId,
        };

        return Promise.resolve({ status: status, data: additionalOrganizationInfo });

    }).catch(function (error) {
        //console.log("error caught from loadCompletedPSETestBatches()");
        //console.log(error);
        status = STATUSES.ERROR;;
        return Promise.reject({ status: status, data: error });
    });
    return res;

};



const submitEditOrganizationData = async (passedData, formInfo, nameConverter, addErrorMessages, clearErrorMessages, getFieldValue, additionalOrganizationInfo) => {
    var orgType = passedData.orgType;
    clearErrorMessages(formInfo.data);
    const loginState = store.getState().loginInfo;
    //console.log("submit file");

    var request = {
        orgDetails: {
            "organizationId": additionalOrganizationInfo.organizationId,
            "organizationTypeId": additionalOrganizationInfo.organizationTypeId,
            "name": getFieldValue("orgName", formInfo.data),
            "psoId": getFieldValue("orgId", formInfo.data).toUpperCase(),
            "website": getFieldValue("orgURL", formInfo.data),
            "address1": getFieldValue("orgAddr1", formInfo.data),
            "address2": getFieldValue("orgAddr2", formInfo.data),
            "city": getFieldValue("orgCity", formInfo.data),
            "regionId": getFieldValue("orgState", formInfo.data),
            "zip": getFieldValue("orgZip", formInfo.data),
            "zipExtension": getFieldValue("orgZipExt", formInfo.data),
            "phone": getFieldValue("orgPhone", formInfo.data),
            "extension": getFieldValue("orgPhoneExt", formInfo.data),
            "fax": getFieldValue("orgFax", formInfo.data),
            "statusId": getFieldValue("orgStatus", formInfo.data),
            //"scpEnroll": getFieldValue("orgIsSCPEnrolled",formInfo.data),
            //"scpEnrollDate": getFieldValue("orgSCPEnrollDate",formInfo.data),
            "testOrg": getFieldValue("orgIsTest", formInfo.data),
            "agreementEffectiveDate": getFieldValue("agreementEffectiveDate", formInfo.data),
            "listingEffectiveDate": getFieldValue("listingEffectiveDate", formInfo.data),
            "agreementEndDate": getFieldValue("agreementEndDate", formInfo.data),
            "listingEndDate": getFieldValue("listingEndDate", formInfo.data)
        },
        password: getFieldValue("password", formInfo.data)
    }

    var url = '/api/manage/' + orgType + '/updateOrganization';

    var status = STATUSES.SUCCESS;

    const token = "Bearer " + loginState.token;
    const res = await http.post(url, request, {
        headers: {
            "Authorization": token
        }
    }).then(res => {
        var x = 0;
        var isFirst = false;
        for (const [key, value] of Object.entries(nameConverter)) {
            //console.log(`Key: ${key}, Value: ${value}`);

            var d = res.fieldErrors;
            var values = d[key];

            if (values != null) {
                if (x == 0) {
                    isFirst = true;
                }
                else {
                    isFirst = false;
                }
                addErrorMessages(value, key, res, isFirst);
                status = STATUSES.ERROR;
                x = x + 1;
            }


        }

        return Promise.resolve({ status: status, data: res });

    }).catch(function (error) {
        //console.log("error caught from loadCompletedPSETestBatches()");
        //console.log(error);
        status = STATUSES.ERROR;;
        return Promise.reject({ status: status, data: error });
    });
    return res;
};

// generate organization status report
const generateOrgStatusRpt = async (token) => {

    let status = STATUSES.SUCCESS;
    // reference to StatusReportRequest.java
    let body = {
        statusIdList: [21, 22],
        statusNameList: ["Active", "Inactive"],
        reportFileName: "Organization Status Report"
    }

    const url = "/api/report/orgStatus";
    const res = await httpDownload.post(url, body, {
        responseType: "blob",
        headers: {
            "Authorization": token
        }
    }).then((res) => {
        //console.log("generateOrgStatusRpt", res);
        return Promise.resolve({ status: status, data: res });
    }).catch(function (error) {

        status = STATUSES.ERROR;;
        return Promise.reject({ status: status, data: error });
    });

    return res;
};

// save PSO History info
const generatePSOHistoryInfo = async (token) => {

    let status = STATUSES.SUCCESS;

    const url = "/api/manage/PSO/savePSOHistoryinfo";
    const body = {}
    let response = {}

    const res = await httpDownload.post(url, body, {
        responseType: "blob",
        headers: {
            "Authorization": token
        }
    }).then((res) => {
        response = { status: status, data: res};
        return res.data.text();
    }).then((res) => {
        response.statusJson = JSON.parse(res);
        return response;
    }).catch(function (error) {

        status = STATUSES.ERROR;
        return Promise.reject({ status: status, data: error });
    });

    return res;
};


export { getOrganizationByType, loadFormInfo, submitCreateOrganizationData, getEditOrgData, submitEditOrganizationData,
    generateOrgStatusRpt, generatePSOHistoryInfo };